import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../client/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_busclient_13d094a8 from 'nuxt_plugin_busclient_13d094a8' // Source: ../client/plugins/bus.client.js (mode: 'client')
import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_integrationswisepopsed64aec4_b3d55c72 from 'nuxt_plugin_integrationswisepopsed64aec4_b3d55c72' // Source: ./integrations.wisepops.ed64aec4.js (mode: 'client')
import nuxt_plugin_integrationstiktok9a81d56c_fb0c3a24 from 'nuxt_plugin_integrationstiktok9a81d56c_fb0c3a24' // Source: ./integrations.tiktok.9a81d56c.js (mode: 'client')
import nuxt_plugin_integrationssteelhousee6a664a2_2ab5f15a from 'nuxt_plugin_integrationssteelhousee6a664a2_2ab5f15a' // Source: ./integrations.steelhouse.e6a664a2.js (mode: 'client')
import nuxt_plugin_integrationspinterest6a7e9670_65a1328a from 'nuxt_plugin_integrationspinterest6a7e9670_65a1328a' // Source: ./integrations.pinterest.6a7e9670.js (mode: 'client')
import nuxt_plugin_integrationsliveintent35111e7c_709ffaf9 from 'nuxt_plugin_integrationsliveintent35111e7c_709ffaf9' // Source: ./integrations.liveintent.35111e7c.js (mode: 'client')
import nuxt_plugin_integrationslistrak468de98c_f14e5de0 from 'nuxt_plugin_integrationslistrak468de98c_f14e5de0' // Source: ./integrations.listrak.468de98c.js (mode: 'client')
import nuxt_plugin_integrationsheap31053a58_7174162a from 'nuxt_plugin_integrationsheap31053a58_7174162a' // Source: ./integrations.heap.31053a58.js (mode: 'client')
import nuxt_plugin_integrationsfacebook4a3b4e84_2424a150 from 'nuxt_plugin_integrationsfacebook4a3b4e84_2424a150' // Source: ./integrations.facebook.4a3b4e84.js (mode: 'client')
import nuxt_plugin_integrationsblisspoint74a84608_e0a07dba from 'nuxt_plugin_integrationsblisspoint74a84608_e0a07dba' // Source: ./integrations.bliss-point.74a84608.js (mode: 'client')
import nuxt_plugin_integrationsbing09b358f8_2ab17724 from 'nuxt_plugin_integrationsbing09b358f8_2ab17724' // Source: ./integrations.bing.09b358f8.js (mode: 'client')
import nuxt_plugin_integrationsamplitude9646c632_7ee1591e from 'nuxt_plugin_integrationsamplitude9646c632_7ee1591e' // Source: ./integrations.amplitude.9646c632.js (mode: 'client')
import nuxt_plugin_portalvue_2f63a5cd from 'nuxt_plugin_portalvue_2f63a5cd' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_focusvisible_6b5478d6 from 'nuxt_plugin_focusvisible_6b5478d6' // Source: ./nuxt-polyfill/focus-visible.js (mode: 'all')
import nuxt_plugin_smoothscrollpolyfill_72a4289e from 'nuxt_plugin_smoothscrollpolyfill_72a4289e' // Source: ./nuxt-polyfill/smoothscroll-polyfill.js (mode: 'all')
import nuxt_plugin_intersectionobserver_5167c258 from 'nuxt_plugin_intersectionobserver_5167c258' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_rollbarclient_1181ec22 from 'nuxt_plugin_rollbarclient_1181ec22' // Source: ./rollbar.client.js (mode: 'client')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_7007b3d1 from 'nuxt_plugin_deviceplugin_7007b3d1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../client/plugins/filters (mode: 'all')
import nuxt_plugin_fontawesome_b8d42804 from 'nuxt_plugin_fontawesome_b8d42804' // Source: ../client/plugins/fontawesome (mode: 'all')
import nuxt_plugin_inject_5d3a56f2 from 'nuxt_plugin_inject_5d3a56f2' // Source: ../client/plugins/inject (mode: 'all')
import nuxt_plugin_scrollto_ee90aa76 from 'nuxt_plugin_scrollto_ee90aa76' // Source: ../client/plugins/scroll-to (mode: 'all')
import nuxt_plugin_announcer_2aca1fa6 from 'nuxt_plugin_announcer_2aca1fa6' // Source: ../client/plugins/announcer.client (mode: 'client')
import nuxt_plugin_zendesk_42443733 from 'nuxt_plugin_zendesk_42443733' // Source: ../client/plugins/zendesk.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en","data-version":"v1.136.8"},"titleTemplate":function anonymous(titleChunk
) {
return titleChunk
        ? `${titleChunk} - HUM Nutrition`
        : 'HUM Nutrition | Vitamins for Skin, Body & Mood'
},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"google-site-verification","content":"SE_2u6QOpbWmp_B0hLVCHhBOWx0SNOdfxwWzP_WGBLU"},{"name":"p:domain_verify","content":"64772a904b15e23146912c671beec4d1"},{"name":"format-detection","content":"telephone=no"},{"hid":"description","name":"description","content":"Discover the best vitamins & supplements for your skin, hair, body & mood. Formulated by experts with active ingredients that actually work. Clinically proven - Clean and natural - Rigorously tested - Demonstrated results. #startwithin"},{"hid":"og:site_name","name":"og:site_name","content":"HUM Nutrition"},{"hid":"og:description","name":"og:description","content":"Discover the best vitamins & supplements for your skin, hair, body & mood. Formulated by experts with active ingredients that actually work. Clinically proven - Clean and natural - Rigorously tested - Demonstrated results. #startwithin"},{"hid":"fb:admins","name":"fb:admins","content":"6312912"},{"hid":"fb:app_id","name":"fb:app_id","content":"196120550516966"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fcdn.humnutrition.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fuse.typekit.net","crossorigin":"anonymous"},{"rel":"preload","href":"https:\u002F\u002Fcdn.humnutrition.com\u002Fneutraface\u002FNeutraface_display-bold.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"https:\u002F\u002Fcdn.humnutrition.com\u002Fassets\u002Ffavicon_16x16.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"https:\u002F\u002Fcdn.humnutrition.com\u002Fassets\u002Ffavicon_32x32.png"}],"script":[{"hid":"amplitude","innerHTML":"\n      function getUtmSource() {\n        const params = new URLSearchParams(window.location.search);\n        const utm_source = params.get('utm_source');\n        const value = utm_source === null ? \"\" : utm_source.replace(\u002F\\+\u002Fg, \" \")\n        return value;\n      }\n\n      ;(function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement(\"script\")\n      ;r.type=\"text\u002Fjavascript\"\n      ;r.integrity=\"sha384-u0hlTAJ1tNefeBKwiBNwB4CkHZ1ck4ajx\u002FpKmwWtc+IufKJiCQZ+WjJIi+7C6Ntm\"\n      ;r.crossOrigin=\"anonymous\";r.async=true\n      ;r.src=\"https:\u002F\u002Fcdn.amplitude.com\u002Flibs\u002Famplitude-8.1.0-min.gz.js\"\n      ;r.onload=function(){if(!e.amplitude.runQueuedFunctions){\n      console.log(\"[Amplitude] Error: could not load SDK\")}}\n      ;var i=t.getElementsByTagName(\"script\")[0];i.parentNode.insertBefore(r,i)\n      ;function s(e,t){e.prototype[t]=function(){\n      this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}\n      var o=function(){this._q=[];return this}\n      ;var a=[\"add\",\"append\",\"clearAll\",\"prepend\",\"set\",\"setOnce\",\"unset\",\"preInsert\",\"postInsert\",\"remove\"]\n      ;for(var c=0;c\u003Ca.length;c++){s(o,a[c])}n.Identify=o;var u=function(){this._q=[]\n      ;return this}\n      ;var l=[\"setProductId\",\"setQuantity\",\"setPrice\",\"setRevenueType\",\"setEventProperties\"]\n      ;for(var p=0;p\u003Cl.length;p++){s(u,l[p])}n.Revenue=u\n      ;var d=[\"init\",\"logEvent\",\"logRevenue\",\"setUserId\",\"setUserProperties\",\"setOptOut\",\"setVersionName\",\"setDomain\",\"setDeviceId\",\"enableTracking\",\"setGlobalUserProperties\",\"identify\",\"clearUserProperties\",\"setGroup\",\"logRevenueV2\",\"regenerateDeviceId\",\"groupIdentify\",\"onInit\",\"logEventWithTimestamp\",\"logEventWithGroups\",\"setSessionId\",\"resetSessionId\"]\n      ;function v(e){function t(t){e[t]=function(){\n      e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}\n      for(var n=0;n\u003Cd.length;n++){t(d[n])}}v(n);n.getInstance=function(e){\n      e=(!e||e.length===0?\"$default_instance\":e).toLowerCase()\n      ;if(!Object.prototype.hasOwnProperty.call(n._iq,e)){n._iq[e]={_q:[]};v(n._iq[e])\n      }return n._iq[e]};e.amplitude=n})(window,document);\n\n      amplitude.getInstance().init(\"6241de20ac9410e442ffc49c9c122909\", null, {\n        includeFclid: true,\n        includeGclid: true,\n        includeUtm: true,\n        includeReferrer: true\n      });\n      amplitude.setVersionName('v1.136.8')\n    "},{"src":"https:\u002F\u002Fcdn.humnutrition.com\u002Fassets\u002Fjquery.min.js","type":"text\u002Fjavascript","async":true},{"json":{"@context":"http:\u002F\u002Fschema.org","@type":"Organization","name":"HUM Nutrition","logo":"https:\u002F\u002Fcdn.humnutrition.com\u002Fassets\u002Flogomark.png","url":"https:\u002F\u002Fwww.humnutrition.com","description":"Beauty starts from within. Take the genius HUM quiz and discover vitamins & supplements for flawless skin, fuller hair and a healthy beautiful body.","email":"healthy@humnutrition.com","telephone":"888-647-8880","address":{"@type":"PostalAddress","addressLocality":"West Hollywood","addressRegion":"CA","postalCode":"90069","streetAddress":"750 N. San Vicente Blvd, Suite 1550"},"sameAs":["https:\u002F\u002Fwww.facebook.com\u002Fhumnutrition","https:\u002F\u002Ftwitter.com\u002Fhumnutrition","https:\u002F\u002Fwww.instagram.com\u002Fhumnutrition\u002F","http:\u002F\u002Fwww.youtube.com\u002Fchannel\u002FUCcwy4Ev5RlWtTFiN0wLa1ng","http:\u002F\u002Fpinterest.com\u002Fhumnutrition"]},"type":"application\u002Fld+json"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-57MJ6M')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-57MJ6M&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_busclient_13d094a8 === 'function') {
    await nuxt_plugin_busclient_13d094a8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationswisepopsed64aec4_b3d55c72 === 'function') {
    await nuxt_plugin_integrationswisepopsed64aec4_b3d55c72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationstiktok9a81d56c_fb0c3a24 === 'function') {
    await nuxt_plugin_integrationstiktok9a81d56c_fb0c3a24(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationssteelhousee6a664a2_2ab5f15a === 'function') {
    await nuxt_plugin_integrationssteelhousee6a664a2_2ab5f15a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationspinterest6a7e9670_65a1328a === 'function') {
    await nuxt_plugin_integrationspinterest6a7e9670_65a1328a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsliveintent35111e7c_709ffaf9 === 'function') {
    await nuxt_plugin_integrationsliveintent35111e7c_709ffaf9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationslistrak468de98c_f14e5de0 === 'function') {
    await nuxt_plugin_integrationslistrak468de98c_f14e5de0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsheap31053a58_7174162a === 'function') {
    await nuxt_plugin_integrationsheap31053a58_7174162a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsfacebook4a3b4e84_2424a150 === 'function') {
    await nuxt_plugin_integrationsfacebook4a3b4e84_2424a150(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsblisspoint74a84608_e0a07dba === 'function') {
    await nuxt_plugin_integrationsblisspoint74a84608_e0a07dba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsbing09b358f8_2ab17724 === 'function') {
    await nuxt_plugin_integrationsbing09b358f8_2ab17724(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsamplitude9646c632_7ee1591e === 'function') {
    await nuxt_plugin_integrationsamplitude9646c632_7ee1591e(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2f63a5cd === 'function') {
    await nuxt_plugin_portalvue_2f63a5cd(app.context, inject)
  }

  if (typeof nuxt_plugin_focusvisible_6b5478d6 === 'function') {
    await nuxt_plugin_focusvisible_6b5478d6(app.context, inject)
  }

  if (typeof nuxt_plugin_smoothscrollpolyfill_72a4289e === 'function') {
    await nuxt_plugin_smoothscrollpolyfill_72a4289e(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_5167c258 === 'function') {
    await nuxt_plugin_intersectionobserver_5167c258(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rollbarclient_1181ec22 === 'function') {
    await nuxt_plugin_rollbarclient_1181ec22(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7007b3d1 === 'function') {
    await nuxt_plugin_deviceplugin_7007b3d1(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_b8d42804 === 'function') {
    await nuxt_plugin_fontawesome_b8d42804(app.context, inject)
  }

  if (typeof nuxt_plugin_inject_5d3a56f2 === 'function') {
    await nuxt_plugin_inject_5d3a56f2(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollto_ee90aa76 === 'function') {
    await nuxt_plugin_scrollto_ee90aa76(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_announcer_2aca1fa6 === 'function') {
    await nuxt_plugin_announcer_2aca1fa6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_zendesk_42443733 === 'function') {
    await nuxt_plugin_zendesk_42443733(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
